import React from "react"
import { Box, Button } from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"
import { FiltersChips } from ".."
import { useQueryGroups, useQueryLocations, useQueryRoles, useQueryTrainingCourses } from "../../data"
import { TrainingFiltersButton } from "./TrainingFiltersButton"

const useStyles = makeStyles((theme) => ({
  filter: {
    backgroundColor: theme.palette.shaded.filter,
  },
  tableHead: {
    position: "sticky",
    top: theme.dimensions.header.height,
    backgroundColor: "white",
    zIndex: 1000,
  },
  tableCellCenter: {
    textAlign: "center",
  },
  clearAllLink: {
    whiteSpace: "nowrap",
  },
  infiniteScrollWrapper: {
    "&&>div": {
      display: "contents",
    },
  },
  infiniteScroll: {
    display: "contents",
  },
  button: {
    height: 36.5,
  },
}))

const TrainingFiltersPanel = ({
  filters,
  filtersOptions = {
    hasCourses: true,
    hasGroups: true,
    hasLocations: true,
    hasTrainingStatus: true,
    hasAccreditationStatus: true,
  },
  onChange,
  onClear,
  onDelete,
}) => {
  const classes = useStyles()
  const { data: groupsData } = useQueryGroups()
  const { data: locationsData } = useQueryLocations()
  const { data: rolesData } = useQueryRoles()
  const { data: trainingCoursesData } = useQueryTrainingCourses()

  const data = {
    groupsData,
    locationsData,
    rolesData,
    trainingCoursesData,
  }

  return (
    <Box display="flex" flexDirection="row">
      <Box px={2} display="flex" flexGrow={1} className={classes.filter}>
        <Box py={2} pr={2}>
          <TrainingFiltersButton filters={filters} onFilterChange={onChange} options={filtersOptions} />
        </Box>
        <Box display="flex" alignItems="center">
          <FiltersChips data={data} filters={filters} onDelete={onDelete} />
        </Box>
        {filters.length > 0 && (
          <Box ml="auto" pl={2} display="flex" alignItems="center">
            <Button className={classes.clearAllLink} color="primary" onClick={onClear}>
              Clear all
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export { TrainingFiltersPanel }
